/* eslint-disable vue/no-unused-components */
<template>
  <div class="deal-offer-section">
    <headerCustom></headerCustom>
    <div class="template main-content sidenav-part ng-scope">
      <!-- <div id="progressBar">
    <div class="loader"></div>
      </div>-->
      <div>
        <div class="heading-sec">
          <div class="row">
            <div class="col-md-9">
              <div class="heading-profile">
                <h3>
                  Deals &amp; Offers
                </h3>
              </div>
            </div>
          </div>
        </div>
        <!-- Top Bar Chart -->
        <div class="panel-content">
          <div class="row">
            <div class="col-md-12">
              <div class="widget">
                <div class="table-area">
                  <div class="widget-title">
                    <div class="float-right"></div>
                    <div class="d-flex">
                      <div>
                        <h6>
                          List of Deals &amp; Offers
                          <span class="tableTotal">(Total : {{ totalCount }})</span>
                        </h6>
                      </div>
                      <div class=" ml-3 ">
                        <b-button variant="success" @click="generateExcelForAllOffersNDeals(page)"
                          >Download</b-button
                        >
                      </div>
                      <div class="ml-auto">
                        <form class="search-form mr-form">
                          <input
                            type="text "
                            class="form-control"
                            v-model="searchText"
                            @input="viewOffersNDealsList(1)"
                            placeholder="Search Here..."
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table text-nowrap">
                      <thead>
                        <tr>
                          <th>Sr.No.</th>
                          <th>Name</th>
                          <th>
                            <b-dropdown :text="selected1 ? selected1.text : 'Package'">
                              <b-dropdown-item
                                :disabled="option.disabled"
                                @click="select1(option)"
                                v-for="option in packages"
                                :key="option.value"
                              >
                                <div class="text">
                                  {{ option.text }}
                                </div>
                              </b-dropdown-item>
                            </b-dropdown>
                          </th>
                          <th>Offer Name</th>
                          <th>Offer Type</th>
                          <th>Offer Period</th>
                          <th>Offer Amount</th>
                          <th>
                            <b-dropdown :text="selected2 ? selected2.text : 'Verify Status'">
                              <b-dropdown-item
                                :disabled="option.disabled"
                                @click="selectedStatus(option)"
                                v-for="option in status"
                                :key="option.value"
                              >
                                <div class="text">
                                  {{ option.text }}
                                </div>
                              </b-dropdown-item>
                            </b-dropdown>
                          </th>
                          <th>City</th>
                          <th>State</th>
                          <th>Country</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in offersNDeals" v-bind:key="item._id">
                          <td>{{ index + 1 + (page - 1) * 10 }}</td>
                          <td>
                            <div v-if="item.hotel">{{ item.hotel.name }}</div>
                          </td>
                          <td>
                            <div>Package</div>
                          </td>
                          <td>
                            <div>{{ item.offer.name }}</div>
                          </td>
                          <td>
                            <div>{{ item.offerType }}</div>
                          </td>
                          <td>
                            <div>
                              {{ item.offer.offerPeriodStart | moment("LL") }} -
                              {{ item.offer.offerPeriodEnd | moment("LL") }}
                            </div>
                          </td>
                          <td>
                            <div>{{ item.totalAmount }}</div>
                          </td>
                          <td>
                            <div>{{ item.status }}</div>
                          </td>
                          <td>
                            <div v-if="item.hotel">
                              {{ item.hotel.city }}
                            </div>
                          </td>
                          <td>
                            <div v-if="item.hotel">{{ item.hotel.state }}</div>
                          </td>
                          <td>
                            <div v-if="item.hotel">{{ item.hotel.country }}</div>
                          </td>
                          <td>
                            <router-link
                              class="btn btn-primary"
                              :to="{ name: 'deals-offers-form', params: { id: item._id } }"
                              append
                            >
                              <!-- <router-link class="btn btn-primary" to="/deals-offers-form" append> -->
                              <b-icon-eye></b-icon-eye>
                            </router-link>
                          </td>
                        </tr>
                        <div>
                          <deletemodal
                            :mymodal="blogData"
                            v-on:conformModal="deleteBlogs"
                          ></deletemodal>
                        </div>
                        <!-- end v-repeat -->
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="table-body-contents text-center m-3 font-size-md font-weight-bold text-muted"
                    v-if="offersNDeals.length === 0"
                  >
                    No Data Found
                  </div>
                  <div class="text-center" v-if="offersNDeals.length >= 1">
                    <b-pagination
                      class="mb-0 float-right"
                      v-model="page"
                      align="center"
                      :total-rows="totalCount"
                      :per-page="formData.limit"
                      @input="viewOffersNDealsList(page)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerCustom from "@/components/Header.vue";
import service from "@/service/apiservice";
import deletemodal from "@/components/deletemodal.vue";
import moment from "moment";

export default {
  components: {
    headerCustom,
    deletemodal
  },
  data() {
    return {
      id: "",
      logs: {
        idToDelete: ""
      },
      currentPage: 1,
      searchText: "",
      offersNDeals: [],
      page: 1,
      formData: { limit: 10 },
      totalCount: 0,
      perPage: 10,
      errors: [],
      data: "",
      email: "",
      blogData: {},
      selected1: null,
      selected2: null,
      packages: [
        {
          text: "package",
          value: "1"
        },
        {
          text: "package",
          value: "2"
        }
      ],
      status: [
        {
          text: "All",
          value: "All"
        },
        {
          text: "Active",
          value: "Active"
        },
        {
          text: "Not Active",
          value: "Not Active"
        }
      ]
    };
  },
  created() {
    this.viewOffersNDealsList(this.page);
  },
  methods: {
    viewOffersNDealsList(pageNo) {
      this.offersNDeals = [];
      this.formData.page = pageNo;
      this.formData.limit = this.perPage;
      this.formData.search = this.searchText;
      service.viewOffersNDealsList(this.formData, data => {
        if (data.status === 200) {
          this.offersNDeals = data.data.result;
          this.totalCount = data.data.TotalCount;
        } else {
        }
      });
    },
    generateExcelForAllOffersNDeals() {
      service.generateExcelForAllOffersNDeals({}, data => {
        service.downloadExcel(data, "OffersNDeals_List");
      });
    },
    deleteBlogById(user) {
      this.blogData = user;
    },
    deleteBlogs(blog) {
      service.deleteBlogs(blog._id, result => {
        if (result.code == 200) {
          this.$toaster.success("Blogs Deleted");
          this.viewOffersNDealsList(1);
        } else {
          this.$toaster.errors("Something went wrong");
        }
      });
    },
    select1(option) {
      this.selected1 = option;
    },
    selectedStatus(option) {
      this.selected2 = option;
      if (option.text == "All") {
        this.formData.type = option.value;
        this.formData.status = "";
      } else {
        this.formData.status = option.value;
        this.formData.type = "";
      }
      this.viewOffersNDealsList(this.page);
    }
  }
};
</script>

<style lang="scss">
.deal-offer-section {
  .text {
    color: black;
  }
  .btn-secondary {
    background: transparent;
    border-color: transparent;
    color: black;
    box-shadow: none;
    font-weight: 700;
    &:hover,
    &:focus,
    &:active {
      background: transparent;
      border-color: transparent;
      color: black;
      box-shadow: none;
    }
  }
  .table .btn {
    padding: 0px 6px;
  }
}
</style>
